import { LoginForm } from '@/pages/login'
import axios from '@/services/axios'

const login = async (data: LoginForm) => {
	const response = await axios.post('/auth/login', data)
	return response.data
}

const verifyAdminOtp = async (data: { email: string; otp: string }) => {
	const response = await axios.post('/auth/verify-admin-otp', data)
	return response.data
}

const registerUser = async (data: any) => {
	const response = await axios.post('/auth/register', data)
	return response.data
}

const updatePassword = async (data: {
	email: string
	oldPassword: string
	newPassword: string
}) => {
	const response = await axios.post('/auth/change-password', data)
	return response.data
}

const forgotPassword = async (data: { email: string }) => {
	const response = await axios.post('/auth/forgot-password', data)
	return response.data
}

const verifyEmail = async (data: { email: string }) => {
	const response = await axios.post('/auth/is-email-already-exist', data)
	return response.data
}

const authService = {
	login,
	verifyAdminOtp,
	registerUser,
	forgotPassword,
	updatePassword,
	verifyEmail,
}

export default authService
